import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const AdvanceAudit = (filteredInfos,role) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 100
        },
        {
            title: '合同编号',
            dataIndex: 'dataRaw.contractNumber',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '销售',
            dataIndex: 'dataRaw.sale.name',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesName || [],
        },
        {
            title: '合同金额',
            dataIndex: 'dataRaw.contractAmount',
            key: 'contractAmount'
        },
        {
            title: '垫付款金额',
            dataIndex: 'dataRaw.paymentAmount',
            key: 'paymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.paymentAmount || [],
        },
        {
            title: '垫付款时间',
            dataIndex: 'dataRaw.paymentDate',
            key: 'paymentDate'
        },
        {
            title: '付款单位',
            dataIndex: 'dataRaw.invoiceTitle',
            key: 'invoiceTitle',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceTitle || [],
        },
        {
            title: '收款单位',
            dataIndex: 'dataRaw.receivingUnit',
            key: 'receivingUnit',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.receivingUnit || [],
        },
        {
            title: '创建人',
            dataIndex: 'sponsor',
            key: 'sponsor',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sponsor || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime'
        },
        {
            title: '审核人员',
            dataIndex: 'operator',
            key: 'operator',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['ALL', 'SUCCESS', 'DEFEAT'],
            filteredValue: filteredInfo.operator || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核时间',
            dataIndex: 'auditTime',
            key: 'auditTime',
            roles: ['ALL', 'SUCCESS', 'DEFEAT']
        },
        {
            title: '审核状态',
            dataIndex: 'status',
            key: 'status',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'status'
            },
            filteredValue: filteredInfo.status || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },

        {
            title: '认领备注',
            dataIndex: 'remark',
            key: 'remark'
        },
    ].filter(item => item?.roles?.includes(role) || !item.roles || !role)
}
